import PropTypes from 'prop-types';
import { useTranslation } from '@aimsos/i18n';
import { IconHighlight } from '@aimsos/ui';

import PickerOption from './PickerOption.jsx';
import PickerOptionGroup from './PickerOptionGroup.jsx';

import { Boxes, Table2 } from 'lucide-react';

const SOURCE_TYPES = Object.freeze([
  Object.freeze({ id: 'dataset', icon: Table2 }),
  Object.freeze({ id: 'entity', icon: Boxes }),
]);

/**
 * `DATA SOURCE` — start from a pre-built dataset, or from a raw entity
 * (CT-5191).
 *
 * A real radio group, not two independent buttons: the two options are mutually
 * exclusive and a screen reader has to hear "1 of 2 selected", not two unrelated
 * toggles.
 */
function DataSourceTypePicker({ value, onChange }) {
  const { t } = useTranslation('dashboards');

  return (
    <PickerOptionGroup
      ariaLabel={t('widgetBuilder.data.sourceType.title')}
      columns={2}
      className="grid gap-3 sm:grid-cols-2"
    >
      {SOURCE_TYPES.map(({ id, icon }) => (
        <PickerOption
          key={id}
          value={id}
          selected={value === id}
          onSelect={onChange}
          className="p-4"
        >
          <div className="flex min-w-0 items-start gap-3">
            <IconHighlight icon={icon} bgColor="Primary" iconColor="PrimaryAlt" size="small" />
            <div className="flex min-w-0 flex-col gap-0.5">
              <p className="m-0 text-sm font-semibold text-content">
                {t(`widgetBuilder.data.sourceType.${id}.title`)}
              </p>
              <p className="m-0 text-xs text-content-secondary">
                {t(`widgetBuilder.data.sourceType.${id}.description`)}
              </p>
            </div>
          </div>
        </PickerOption>
      ))}
    </PickerOptionGroup>
  );
}

DataSourceTypePicker.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default DataSourceTypePicker;
